<template>
	<div id="drawmoney" class="page" v-if="loaded">
		<div class='withdrawal'>
			<div class='withdrawal-money'>可提现金额：<span>{{info.withdraw_money}}</text></span></div>
			<div class='shenqing'>申请提现金额</div>
			<div class='tixian-kuang'>
			  <span>￥</span>
			  <div class='shuru'><input type='digit' adjust-position="false" v-model="submit_money" v-on:blur='event_money_blur' v-on:focus='event_money_focu'/></div>
			</div>
			<div v-if="withdraw_online != '1'">
			  <div class='shenqing'>支付宝或银行卡账号</div>
			  <div class='tixian-kuang'>
				<div class='shuru' style="width:100%;"><input type='digit' adjust-position="false" bindinput="event_bank_number"/></div>
			  </div>
			</div>
			<div class='tixian-button'>
			  <button v-on:click="event_submit">立即提现</button>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			info:{},
			submit_money:0,
			withdraw_online:1,
			bank_number:''
		}
	},
	created () {
		this.$https.post("/api/distribution/index",this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.info = res.data.data
			this.withdraw_online = this.$store.state.config.data.withdraw_online == '1' ? 1 : 0
			this.loaded = true
		});
	},
	methods: {
		event_money_focu(){
			if (this.submit_money == '0' || this.submit_money == 0){
			  this.submit_money = ''
			}
		},

		event_money_blur(){
			this.submit_money = parseFloat(this.submit_money)
		},
		event_submit(){
			if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(this.submit_money)){
				Toast.text({
					duration: 1000,
					message: '请输入正确的金额'
				})
			  return false;
			}

			if (parseFloat(this.submit_money) > parseFloat(this.info.withdraw_money)) {
				Toast.text({
					duration: 1000,
					message: '您没有这么多可提现金额'
				})
				return false;
			}
			Toast.loading('正在处理..')
			if (this.withdraw_online){
				//自动提现
				this.$https.post("/api/withdraw/submit",this.$qs.stringify({
					token:this.$store.state.token,
					money: this.submit_money
				})).then((res) => {
					Toast.success(res.data.message)
					this.created();
				}).catch((res) => {
					Toast.text(res.data.message)
				});
			}else{
				Dialog.confirm({
					title: title,
					message: '请确认您的支付宝或银行卡账号正确',
					skin,
					showCancelButton: true
				}).then(() => {
					app.pr('/api/withdraw/submit', {
						money: this.submit_money,
						bank_number:this.bank_number
					}).then((res) => {
						Toast.success(res.data.message)
						this.created();
					}).catch((res) => {
						Toast.text(res.data.message)
					});
				}).catch(() => {
				})
			}
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#drawmoney{
		background-color:#ffffff;
		min-height:100vh;
	}
	.withdrawal{
  background: #fff;
  padding: 50px;
}
.withdrawal-money{
  font-size: 16px;
}
.withdrawal-money span{
  color: #28abf2;
}
.shenqing{
  margin-top: 30px;
  font-size: 14px;
}
.tixian-kuang{
  display: flex;
  margin-top: 10px;
}
.tixian-kuang span{
  font-size: 30px;
}
.tixian-kuang input{
  height: 40px;
  width: 100%;
  border:0px;
  border-bottom: 1px solid #ededed;
}
.tixian-button button{
  margin-top: 50px;
  background: #27bfff;
  font-size:14px;
  color: #fff;
  border: 0;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Drawmoney.vue